module.exports = __webpack_public_path__ + "static/media/3 05 Tulleord Falk er riktig.b19e4715.mp3";